import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    gymData: [],
};

const gymDataSlice = createSlice({
    name: 'gymData',
    initialState,
    reducers: {
        setGymData: (state, action) => {
            state.gymData = action.payload;
        },
    },
});

export const { setGymData } = gymDataSlice.actions;
export const selectGymData = (state) => state.gymData.gymData;

export default gymDataSlice.reducer;
